import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import keycloak from './keycloak';

const root = ReactDOM.createRoot(document.getElementById('root'));

const KC_TOKEN_URL = 'https://auth.alphy.pro/realms/alphy_datagreffe/protocol/openid-connect/token';
const KC_CLIENT_ID = 'devpospartner';
const KC_CLIENT_SECRET = 'zJzCv0thzzHztbMSsFspiyJLh3LbshfA';

const urlParams = new URLSearchParams(window.location.search);
const externalToken = urlParams.get('token');
const externalRefreshToken = urlParams.get('refresh_token');
const externalIdToken = urlParams.get('id_token');

// Fonction pour rafraîchir le token avec client_secret
const refreshTokenWithSecret = async (refreshToken) => {
  try {
    const body = new URLSearchParams({
      grant_type: 'refresh_token',
      client_id: KC_CLIENT_ID,
      client_secret: KC_CLIENT_SECRET,
      refresh_token: refreshToken,
    });

    const response = await fetch(KC_TOKEN_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
    });

    if (!response.ok) {
      console.error('Refresh token failed:', await response.text());
      return null;
    }

    return await response.json();
  } catch (error) {
    console.error('Refresh token error:', error);
    return null;
  }
};

// Démarrer le refresh automatique
const startTokenRefresh = (refreshToken, expiresIn) => {
  const refreshInterval = (expiresIn - 30) * 1000;

  const doRefresh = async () => {
    const result = await refreshTokenWithSecret(refreshToken);
    if (result) {
      keycloak.token = result.access_token;
      keycloak.refreshToken = result.refresh_token;
      keycloak.idToken = result.id_token;

      try {
        keycloak.tokenParsed = JSON.parse(atob(result.access_token.split('.')[1]));
        if (result.id_token) {
          keycloak.idTokenParsed = JSON.parse(atob(result.id_token.split('.')[1]));
        }
      } catch (e) {
        console.error('Erreur parsing refreshed token:', e);
      }

      console.log('Token Keycloak rafraîchi avec succès');
      setTimeout(doRefresh, (result.expires_in - 30) * 1000);
    } else {
      // Ne PAS rediriger vers login
      // Le token backend est déjà stocké, l'app fonctionne sans le token Keycloak
      console.warn('Refresh Keycloak échoué, mais le token backend reste valide');
    }
  };

  setTimeout(doRefresh, refreshInterval);
};

if (externalToken) {
  // Nettoyer l'URL
  const cleanUrl = new URL(window.location.href);
  cleanUrl.searchParams.delete('token');
  cleanUrl.searchParams.delete('refresh_token');
  cleanUrl.searchParams.delete('id_token');
  window.history.replaceState({}, document.title, cleanUrl.toString());

  // Injecter le token dans l'instance Keycloak
  keycloak.token = externalToken;
  keycloak.refreshToken = externalRefreshToken || undefined;
  keycloak.idToken = externalIdToken || undefined;
  keycloak.authenticated = true;

  // Parser le access_token
  try {
    const tokenPayload = JSON.parse(atob(externalToken.split('.')[1]));
    keycloak.tokenParsed = tokenPayload;
    keycloak.subject = tokenPayload.sub;

    // Démarrer le refresh automatique
    if (externalRefreshToken && tokenPayload.exp) {
      const expiresIn = tokenPayload.exp - Math.floor(Date.now() / 1000);
      startTokenRefresh(externalRefreshToken, expiresIn);
    }
  } catch (e) {
    console.error('Erreur parsing token:', e);
  }

  // Parser l'id_token
  if (externalIdToken) {
    try {
      keycloak.idTokenParsed = JSON.parse(atob(externalIdToken.split('.')[1]));
    } catch (e) {
      console.error('Erreur parsing id_token:', e);
    }
  }

  console.log('Token externe injecté, authenticated:', keycloak.authenticated);
  console.log('User ID:', keycloak.tokenParsed?.sub);
  console.log('Email:', keycloak.tokenParsed?.email);

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

} else {
  // Flux normal : check-sso
  keycloak.init({
    onLoad: 'check-sso',
    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
    pkceMethod: 'S256',
  }).then((authenticated) => {
    console.log('Keycloak authenticated:', authenticated);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }).catch((error) => {
    console.error('Keycloak init error:', error);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });
}

reportWebVitals();